let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aVzpn")).then(() => parcelRequire('2qdn3'));